import { TranscriptReturn } from '../types/transcript-types';
import { getRecordingSubtitleUrl, getTranscriptDataInRequiredFormat, getFilteredWords } from '../utils/transcriptUtils';

export function fetchTranscript({
  cacheSuffix,
  event,
  broadcast,
  clip_start_time,
  clip_end_time,
  onError
}: {
  cacheSuffix: string;
  event: string;
  broadcast: string;
  clip_start_time?: number;
  clip_end_time?: number;
  onError: (error: string) => void;
}): Promise<TranscriptReturn> {
  return fetch(getRecordingSubtitleUrl(event, broadcast)(`transcript.json?${cacheSuffix}`), { cache: 'force-cache' })
    .then(res => {
      if (res.status >= 400) {
        onError("Oops! We're having trouble loading the transcript. Please check your connection and try again.");
      }
      return res.json();
    })
    .then(words => {
      if (!Array.isArray(words)) {
        return {
          transcript: [],
          fullTranscript: []
        };
      }

      const fullTranscript = getTranscriptDataInRequiredFormat(words);
      const filteredWords = getFilteredWords(words, clip_start_time, clip_end_time);

      return {
        transcript: getTranscriptDataInRequiredFormat(filteredWords),
        fullTranscript
      };
    });
}
